import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { ExerciseXslxHeaders } from "../../../enums/exerciseXslxHeaders";
import { PreviousPaperModel } from "../../../models/ExamModels/PreviousPaperModel/previouspaper.model";
import { PaginationModel } from "../../../models/PaginationModel/pagination.model";
import "./previousPaper.scss"
import { PreviousPaperService } from "../../../services/ExamService/PreviousPaperService/previouspaper.service";
import CourseHeader from "../../../shared/components/AppHeader/index";
import ButtonComponent from "../../../shared/components/ButtonComponent";
import EmptyState from "../../../shared/components/EmptyState";
import PaginationComponent from "../../../shared/components/PaginationComponent";
import { convertJsonToXslx } from "../../../shared/utils/xlsxConverter";
import { AddPaper } from "./AddPaper";
import { PaperCards } from "./PaperCards";
import { DownloadOutlined } from "@ant-design/icons";
import BulkUpload from "../../CourseStructure/Chapters/ChapterActions/BulkUpload";

const PreviousPaper = (props: any) => {
  const { examId } = props.match?.params;
  const [papers, setPapers] = useState<PreviousPaperModel[]>();
  const [meta, setMeta] = useState<PaginationModel>();
  const [showModal, setModalVisiblity] = useState(false);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [showBulkUpload, setBulkUpload] = useState<boolean>(false);

  const handleDownload = () => {
    convertJsonToXslx("questions.xlsx", "Questions", [
      ExerciseXslxHeaders.EXERCISE_ID,
      ExerciseXslxHeaders.QUESTION_CONTENT,
      ExerciseXslxHeaders.QUESTION_IMAGE,
      ExerciseXslxHeaders.ONLY_FREE_TEXT,
      ExerciseXslxHeaders.OPTION1,
      ExerciseXslxHeaders.IMAGE_OPTION1,
      ExerciseXslxHeaders.OPTION2,
      ExerciseXslxHeaders.IMAGE_OPTION2,
      ExerciseXslxHeaders.OPTION3,
      ExerciseXslxHeaders.IMAGE_OPTION3,
      ExerciseXslxHeaders.OPTION4,
      ExerciseXslxHeaders.IMAGE_OPTION4,
      ExerciseXslxHeaders.CORRECT_ANSWER,
      ExerciseXslxHeaders.SOLUTION,
      ExerciseXslxHeaders.SOLUTION_IMAGE,
    ]);
  };
  const fetchPreviousPapers = (pageNumber: number, searchString?: string) => {
    let queryParams = `?page=${pageNumber}&exam_id=${examId}&search=${
      searchString || ""
    }`;

    PreviousPaperService.fetchPreviousPaper(
      queryParams,
      (response: PreviousPaperModel[], meta: PaginationModel) => {
        setPapers(response);
        setMeta(meta);
        console.log(response);
      },
      (error: any) => {}
    );
  };
  useEffect(() => {
    fetchPreviousPapers(1);
  }, []);
  const handleSearch = (value: string) => {
    fetchPreviousPapers(currentPageNumber, value);
  };

  const handlePageChange = (page: number) => {
    fetchPreviousPapers(page);
    setCurrentPageNumber(page);
  };
  return (
    <div className="page-view previous-paper">
      <AddPaper
        examId={examId}
        refreshList={fetchPreviousPapers}
        visible={showModal}
        currentPageNumber={currentPageNumber}
        closeModalHandler={() => setModalVisiblity(false)}
      />
      <BulkUpload
        visible={showBulkUpload}
        closeHandler={() => {
          setBulkUpload(false);
        }}
      />
      <CourseHeader
        headerText="Previous paper"
        handleSearch={handleSearch}
        handleHeaderAction={() => {
          setModalVisiblity(true);
        }}
        buttonText="Paper"
        showBreadCrumb
      />
      {papers?.length ? (
        <>
          <PaperCards
            refreshList={fetchPreviousPapers}
            papers={papers}
            currentPageNumber={currentPageNumber}
            examId={examId}
          />
          <div className="previous-paper__footer">
            <div className="exercises__controllers">
              <ButtonComponent
                type="text"
                iconLeft={<DownloadOutlined />}
                buttonContent="Template Excel"
                onClick={handleDownload}
              />

              <ButtonComponent
                type="primary"
                onClick={() => setBulkUpload(true)}
                buttonContent="Bulk Upload"
              />
            </div>
            <PaginationComponent
              handlePageChange={handlePageChange}
              paginationMeta={meta}
            />
          </div>
        </>
      ) : (
        <EmptyState text={"No papers found."} />
      )}
    </div>
  );
};

export default withRouter(PreviousPaper);
